import { Notifications as MantineNotifications, NotificationsProps } from "@mantine/notifications";
import styles from "./notifications-configurator.module.scss";

/**
 * Notifications system configurator component
 * @param props NotificationsProps
 * @returns NotificationsConfigurator
 */
const Notifications = (props: NotificationsProps) => {
    return (
        <MantineNotifications
            classNames={{ notification: styles["notification"], root: styles["root"] }}
            containerWidth={372}
            position="bottom-right"
            {...props}
        />
    );
};

export default Notifications;
